/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { PageStringSection } from "./pageStringSection";

export class ChangePassword extends PageStringSection {
    button_cancel_label: string = "Labels.lbl_Cancel";
    button_changePassword_label: string = "Labels.lbl_PasswordChange";
    button_save_label: string = "Labels.lbl_Save";
    formItem_confirmNewPassword_ariaLabel: string = "Labels.lbl_PasswordNewConfirm";
    formItem_confirmNewPassword_label: string = "Labels.lbl_PasswordNewConfirm";
    formItem_currentPassword_ariaLabel: string = "Labels.lbl_CurrentPassword";
    formItem_currentPassword_label: string = "Labels.lbl_CurrentPassword";
    formItem_newPassword_ariaLabel: string = "Labels.lbl_PasswordNew";
    formItem_newPassword_label: string = "Labels.lbl_PasswordNew";
    heading_password: string = "Labels.lbl_Password";
    heading_changePassword_label: string = "Labels.lbl_PasswordChange";
    heading_passwordRequirements: string = "Messages.msg_PasswordMustContain";
    text_passwordRequirements_lowerCase: string = "Messages.msg_PasswordRequirements_LowerCaseRequired";
    text_passwordRequirements_minimumCharacters: string = "Messages.msg_PasswordRequirements_MinimumCharacters";
    text_passwordRequirements_number: string = "Messages.msg_PasswordRequirements_NumberRequired";
    text_passwordRequirements_specialCharacters: string = "Messages.msg_PasswordRequirements_SpecialCharactersRequired";
    text_passwordRequirements_upperCase: string = "Messages.msg_PasswordRequirements_UpperCaseRequired";
    text_neverRevealPassword: string = "Messages.msg_NeverRevealPassword";
    message_incorrectPassword: string = "Messages.msg_PasswordIncorrect";
    error_passwordMismatch: string = "Messages.msg_PasswordMismatch";
    error_ChangePasswordField: string = "Messages.msg_PasswordChangeFailed";
}
